// TODO: remove after adding drivers chart types

import { TBChartType } from '../enums'

export const HIDDEN_CHARTS = [
  TBChartType.TOP_DRIVERS,
  TBChartType.UNIQUE_DRIVERS,
]
